import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2386bea4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content"
};
var _hoisted_2 = {
  class: "cont"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, " 已评议", -1);
});

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, " 开始评议", -1);
});

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, " 已评议", -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _component_el_table_column = _resolveComponent("el-table-column");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_table = _resolveComponent("el-table");

  var _component_Pagination = _resolveComponent("Pagination");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "民主评议",
    back: true
  }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", null, _toDisplayString(_ctx.listtit.title), 1), _createElementVNode("span", null, "开始时间:" + _toDisplayString(_ctx.listtit.createTime) + "    结束时间:" + _toDisplayString(_ctx.listtit.endTime), 1)]), _ctx.showid ? (_openBlock(), _createBlock(_component_el_table, {
    key: 0,
    data: _ctx.tableData,
    style: {
      "width": "100%"
    },
    "show-header": false
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        prop: "name",
        label: "Name",
        width: "680"
      }), _createVNode(_component_el_table_column, {
        label: "Operations"
      }, {
        default: _withCtx(function (scope) {
          return [_ctx.self == 1 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "text",
            class: "btn_detail"
          }, {
            default: _withCtx(function () {
              return [_hoisted_3];
            }),
            _: 1
          })) : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "text",
            class: "btn_detail",
            onClick: function onClick($event) {
              return _ctx.hisoryDelete(scope.row);
            }
          }, {
            default: _withCtx(function () {
              return [_hoisted_4];
            }),
            _: 2
          }, 1032, ["onClick"]))];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["data"])) : _createCommentVNode("", true), _ctx.tablelist.length > 0 && _ctx.tablelist[0].participant != '' ? (_openBlock(), _createBlock(_component_el_table, {
    key: 1,
    data: _ctx.tablelist,
    style: {
      "width": "100%"
    },
    "show-header": false
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        prop: "participantName",
        label: "participantName",
        width: "680"
      }), _createVNode(_component_el_table_column, {
        label: "Operations"
      }, {
        default: _withCtx(function (scope) {
          return [scope.row.participantStatus == 1 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "text",
            class: "btn_detail",
            onClick: function onClick($event) {
              return _ctx.hisoryhuDelete(scope.row);
            }
          }, {
            default: _withCtx(function () {
              return [_hoisted_5];
            }),
            _: 2
          }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "text",
            class: "btn_detail",
            onClick: function onClick($event) {
              return _ctx.hisoryhuDelete(scope.row);
            }
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("span", null, _toDisplayString(_ctx.namehu), 1)];
            }),
            _: 2
          }, 1032, ["onClick"]))];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["data"])) : _createCommentVNode("", true), _createVNode(_component_Pagination, {
    pagesize: 10,
    "total-num": _ctx.totalNumTwo,
    onChangPage: _ctx.changPageTwo
  }, null, 8, ["total-num", "onChangPage"])])], 64);
}